import { redirect } from "react-router";
import { getToken } from "src/business-hooks/useToken";

export const loginRouterLoader = (): Response | null => {
  const user = getToken();
  if (user) {
    return redirect("/");
  }
  return null;
};
